







































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import AccordionSelect from '@/components/AccordionSelect.vue'
import Input from '@/components/inputs/Input.vue'
import Confirm from '@/components/Confirm.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import FlowItem from '../../../../components/FlowItem.vue'
import {
  EUserPermissions,
  IPayerType,
  IClaimFlow,
  IUser,
  EClaimFlowType,
  EClaimFlowStatuses
} from '@zunta/configurations'

import { IAccoridionElementItem } from '@/interfaces'
import Api from '@/api'
import { User } from '@/classes/User'

import { UserModule } from '@/store/modules/user.module'
import Select from '@/components/Select.vue'
import GoBack from '@/components/GoBack.vue'

const uniqBy = require('lodash.uniqby')

@Component({
  name: 'CreateBillingFlow',
  components: {
    GoBack,
    Select,
    Icon,
    Input,
    Checkbox,
    AccordionSelect,
    FlowItem,
    ErrorMessages,
    Confirm
  }
})
export default class CreateClaimFlow extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store);
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  EUserPermissions: any = EUserPermissions;
  EClaimFlowType: any = EClaimFlowType;
  user: User = Api.getUser() as User;
  isSaving: boolean = false;
  errors: string[] = [];

  selectedPayerTypes: IPayerType[] = [];
  payerTypeToSelect: IPayerType | null = null;

  flowName: string = 'Default';

  shouldConfirmChangePayerType: boolean = false;
  showSaveFlowPopup: boolean = false;
  reloadPayerTypes: boolean = false;
  claimFlows: any[] = [
    {
      id: undefined,
      user: null,
      status: null,
      timeframe: null,
      type: EClaimFlowType.BILL_AMOUNT_AND_NO_CLAIM
    },
    {
      id: undefined,
      user: null,
      status: null,
      timeframe: null,
      type: EClaimFlowType.SINCE_NO_CLAIM
    },
    {
      id: undefined,
      user: null,
      status: null,
      timeframe: null,
      type: EClaimFlowType.NOT_EQUAL_POSTED_AMOUNT
    },
    {
      id: undefined,
      user: null,
      status: null,
      timeframe: null,
      type: EClaimFlowType.PAID_IN_AGING
    },
    {
      id: undefined,
      user: null,
      status: null,
      timeframe: null,
      type: EClaimFlowType.STILL_PENDING
    },
    {
      user: null,
      status: null,
      timeframe: null,
      type: EClaimFlowType.BY_STATUS
    }
  ]

  get canSave () {
    return this.availablePayerTypes &&
        this.availablePayerTypes.length &&
        this.claimFlows.filter((item: any) => item.user).length
  }

  get statusesListItems () {
    return [
      {
        key: EClaimFlowStatuses.DECLINED,
        value: EClaimFlowStatuses.DECLINED,
        content: 'Denied'
      },
      {
        key: EClaimFlowStatuses.PAID,
        value: EClaimFlowStatuses.PAID,
        content: 'Paid'
      },
      {
        key: EClaimFlowStatuses.PENDING,
        value: EClaimFlowStatuses.PENDING,
        content: 'Pending'
      }
    ]
  }

  get usersList () {
    return this.$store.state.user.users
  }

  get userListItems () {
    return this.usersList.map((user: IUser) => ({
      key: user.id,
      value: user.id,
      content: `${user.firstName} ${user.lastName}`
    }))
  }

  get facilityId () {
    return this.$route.params.id
  }

  get claimFlowId () {
    return this.$route.params.claimFlowId
  }

  get allClaimFlows () {
    return this.$store.state.facility.collectionFlows
  }

  get allFacilities () {
    return this.$store.state.facility.facilities
  }

  get isNew () {
    return !this.claimFlowId
  }

  get facility () {
    return this.$store.state.facility.selectedFacility
  }

  get payerTypes () {
    return this.$store.state.facility.payerTypes
  }

  get activePayerTypes () {
    return this.payerTypes.filter((payerType: IPayerType) => payerType.active)
  }

  get availablePayerTypes () {
    if (this.claimFlowId) {
      return this.activePayerTypes.filter((payerType: IPayerType) => payerType.claimFlowId === Number(this.claimFlowId) || !payerType.claimFlowId)
    }
    return this.activePayerTypes
  }

  get selectedClaimFlowData () {
    return this.$store.state.facility.selectedClaimFlowData
  }

  get isAllPayersTypesSelected () {
    return this.availablePayerTypes.length === this.selectedPayerTypes.length
  }

  get ableToAddFlow () {
    return this.claimFlows.filter((item: any) => item.type === EClaimFlowType.BY_STATUS).length < this.statusesListItems.length
  }

  async mounted () {
    if (!this.facility) {
      await this.facilityModuleInstance.getFacility(this.facilityId)
    }
    await this.userModuleInstance.getManagementUsersList({})
    await this.facilityModuleInstance.fetchPayerTypes(this.facilityId)
    await this.facilityModuleInstance.getFacilityList({})
    if (!this.isNew && this.claimFlowId) {
      this.initByClaimFlow(this.claimFlowId)
    }
  }

  setUser (index: number, field: string, value: any) {
    this.claimFlows[index][field] = value
  }

  async initByClaimFlow (id: number | string) {
    await this.facilityModuleInstance.getClaimFlow(Number(id))
    if (!this.selectedClaimFlowData) {
      return
    }
    const flows = [...this.selectedClaimFlowData.flows]

    if (this.selectedClaimFlowData.flows.findIndex((flow: any) => flow.type === EClaimFlowType.BILL_AMOUNT_AND_NO_CLAIM) === -1) {
      flows.push({
        id: undefined,
        user: null,
        status: null,
        timeframe: null,
        type: EClaimFlowType.BILL_AMOUNT_AND_NO_CLAIM
      })
    }

    if (this.selectedClaimFlowData.flows.findIndex((flow: any) => flow.type === EClaimFlowType.SINCE_NO_CLAIM) === -1) {
      flows.push({
        id: undefined,
        user: null,
        status: null,
        timeframe: null,
        type: EClaimFlowType.SINCE_NO_CLAIM
      })
    }

    if (this.selectedClaimFlowData.flows.findIndex((flow: any) => flow.type === EClaimFlowType.NOT_EQUAL_POSTED_AMOUNT) === -1) {
      flows.push({
        id: undefined,
        user: null,
        status: null,
        timeframe: null,
        type: EClaimFlowType.NOT_EQUAL_POSTED_AMOUNT
      })
    }

    if (this.selectedClaimFlowData.flows.findIndex((flow: any) => flow.type === EClaimFlowType.PAID_IN_AGING) === -1) {
      flows.push({
        id: undefined,
        user: null,
        status: null,
        timeframe: null,
        type: EClaimFlowType.PAID_IN_AGING
      })
    }

    if (this.selectedClaimFlowData.flows.findIndex((flow: any) => flow.type === EClaimFlowType.STILL_PENDING) === -1) {
      flows.push({
        id: undefined,
        user: null,
        status: null,
        timeframe: null,
        type: EClaimFlowType.STILL_PENDING
      })
    }

    if (this.selectedClaimFlowData.flows.findIndex((flow: any) => flow.type === EClaimFlowType.BY_STATUS) === -1) {
      flows.push({
        id: undefined,
        user: null,
        status: null,
        timeframe: null,
        type: EClaimFlowType.BY_STATUS
      })
    }

    flows.sort((a: any, b: any) => {
      if (a.type !== EClaimFlowType.BY_STATUS && b.type === EClaimFlowType.BY_STATUS) {
        return -1
      }
      if (a.type === EClaimFlowType.BY_STATUS && b.type !== EClaimFlowType.BY_STATUS) {
        return 1
      }
      return 0
    })

    this.flowName = this.selectedClaimFlowData.flowName
    this.claimFlows = flows
    this.selectedPayerTypes = this.selectedClaimFlowData.payerTypes
  }

  beforeDestroy () {
    this.facilityModuleInstance.resetSelectedClaimFlowData()
  }

  goBack () {
    this.$router.push({ name: 'management-facilities-settings-claim-flow' })
  }

  toggleAllPayerTypes (selectAllPayers:boolean) {
    if (selectAllPayers) {
      this.selectedPayerTypes = [...this.activePayerTypes]
      return
    }
    this.selectedPayerTypes = []
  }

  togglePayerType (payerType: IPayerType, force: boolean = false) {
    if (this.isPayerTypeSelected(payerType)) {
      this.selectedPayerTypes = this.selectedPayerTypes.filter((sPayerType: IPayerType) => (
        sPayerType.id !== payerType.id
      ))
    } else {
      if (!force) {
        // @ts-ignore
        if (payerType && payerType.claimFlowId && (payerType as IPayerType).claimFlowId.toString() !== this.claimFlowId) {
          this.payerTypeToSelect = payerType
          this.shouldConfirmChangePayerType = true
          return
        }
      } else {
        this.payerTypeToSelect = null
        this.shouldConfirmChangePayerType = false
      }
      delete payerType.claimFlowId
      this.selectedPayerTypes.push(payerType)
    }
  }

  closeConfirmChangePayerTypeModal () {
    this.shouldConfirmChangePayerType = false
    this.payerTypeToSelect = null
    this.reloadPayerTypes = true
    this.$nextTick(() => {
      this.reloadPayerTypes = false
    })
  }

  isPayerTypeSelected (payerType: IPayerType) {
    return !!this.selectedPayerTypes.find((sPayerType: IPayerType) => (
      sPayerType.id === payerType.id
    ))
  }

  addNewFlow () {
    this.claimFlows.push({
      user: null,
      status: null,
      timeframe: null,
      type: EClaimFlowType.BY_STATUS
    })
  }

  closeSaveFlowPopup () {
    this.showSaveFlowPopup = false
  }

  async save () {
    if (!this.canSave) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Please fill required fields',
        header: 'Invalid Data',
        icon: 'warning'
      })
      return
    }
    // if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_COLLECTIONS_FLOW)) {
    //   this.$eventBus.$emit('notify', {
    //     color: 'var(--status-error-color)',
    //     message: 'Permission Denied',
    //     header: 'Modify Claim Flow',
    //     icon: 'warning'
    //   })
    //   return
    // }

    let header
    let message
    let isSuccess = true
    const filteredRules = this.claimFlows.filter((item: any) => item.user)
    const flows = {
        flowName: this.flowName,
        flows: filteredRules,
        payerTypes: this.selectedPayerTypes
    }
    this.isSaving = true
    if (this.isNew) {
      const claimFlow = await this.facilityModuleInstance.createClaimFlow({
        facilityId: this.facilityId,
        data: flows
      })
      header = 'Create Claim Flow'
      if (!claimFlow.id) {
        isSuccess = false
        message = 'Something went wrong'
      } else {
        message = 'Claim Flow successfully created!'
      }
      this.$router.push({
        name: 'management-facilities-settings-create-claim-flow',
        params: {
          facilityId: this.facilityId,
          claimFlowId: claimFlow.id.toString()
        }
      })
    } else {
      const response = await this.facilityModuleInstance.updateClaimFlow({
        claimFlowId: this.claimFlowId,
        data: flows
      })
      header = 'Update Claim Flow'
      if (response === 'OK') {
        message = 'Claim Flow successfully updated!'
      } else {
        isSuccess = false
        message = 'Something went wrong'
      }
    }
    this.$eventBus.$emit('notify', {
      color: isSuccess ? 'var(--status-success-color)' : 'var(--status-error-color)',
      message: message,
      header: header,
      icon: isSuccess ? 'check' : 'warning'
    })
    this.goBack()
    this.isSaving = false
  }
}
